import * as React from 'react';

import { RowTitleField, RowTitlePhotosField } from '../../../../../../components/Field/common';
import { EFieldName } from '../../../../../../types/field';

export interface ITableRowContainerProps {
  title?: string | null;
  name: EFieldName;
}

export const CommonRowTitleContainer = ({ title, name }: ITableRowContainerProps): React.JSX.Element | null => {
  if (!title) {
    return null;
  }

  switch (name) {
    case EFieldName.Photos:
      return <RowTitlePhotosField>{title}</RowTitlePhotosField>;
    default:
      return <RowTitleField>{title}</RowTitleField>;
  }
};
